import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

export default function ProductTitle({ itemName }) {
    const currentLanguage = useSelector(({ language }) => language.currentLanguage);
    const navbarCategory = useSelector(({ navigation }) => navigation.navbarCategory);
    const category = useSelector(({ product }) => product.category);
    const basenameURL = useSelector(({ language }) => language.basenameURL);

    const [categoryName, setCategoryName] = useState("");

    useEffect(() => {
        if (category) {
            const name = currentLanguage === 'TH' ? category.categoryNameTh: category.categoryNameEn;
            setCategoryName(name)
        }
    }, [category])

    return (
        <section
            style={{
                backgroundColor: '#7e7e7e',
                paddingTop: 20,
                paddingBottom: 20
            }}>
            <div className='container relative clearfix'>
                <ol className='breadcrumb'>
                    <li>
                        <Link to={`${basenameURL}`}>
                            {currentLanguage === 'TH'
                                ? navbarCategory[0].categoriesNameTh
                                : navbarCategory[0].categoriesNameEn}
                        </Link>
                    </li>
                    {
                        category && <li><Link to={`${basenameURL}${category.url}`}>{categoryName}</Link></li>
                    }
                    <li className='active'>{itemName}</li>
                </ol>
            </div>
        </section>
    );
}
